const imgTeamMotionWorkImageassets = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img2026923382 = "./assets/figma/087e7cd6-d3b1-4396-a41e-5f4578b435b6.png";
const img2026923372 = "./assets/figma/16660b77-d524-4d65-8c96-597e58fa8deb.png";
const img11843 = "./assets/figma/798f6cf7-9cf1-4156-bea0-bd60d4a79b30.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/7a838bc0-517d-4fb6-a78c-407df0c4470e.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";

export default function TeamMotionWorkImageassets() {
  return (
    <div className="s0 s1" data-node-id="886:1456" data-name="TEAM_MOTION/WORK_IMAGEASSETS">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s234 s235 s9 s10 s236" src={imgTeamMotionWorkImageassets} />
        </div>
      </div>
      <div className="s2 s12 s13 s237 s15" data-node-id="886:1458" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s20 s238 s22" data-node-id="886:1459">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="886:1460">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="886:1461">
            PROJECT OVERVIEW
          </p>
          <div className="s35 s36 s0 s28 s37 s34 s38" data-node-id="886:1462">
            <p className="s39 s40">
              MAIN VIDEO · 1<br aria-hidden />
              MOTION POSTERS · 4
            </p>
            <p className="s39 s40">​</p>
            <p className="s39">​</p>
          </div>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="886:1463">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="886:1464">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="886:1465">
            MEMBERS
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="886:1466">
            김수영
            <br aria-hidden />
            김지현
            <br aria-hidden />
            장아영
            <br aria-hidden />
            정윤성
          </p>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s239 s54" data-node-id="886:1467">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s240 s57" data-node-id="886:1468">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="886:1469">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="886:1470">
          <p className="s39 s40">{`모션팀은 가공되지 않은 아이디어가 다양한 AI 도구를 거치며 새로운 결과로 확장되는 과정을 실험실의 구조와 움직임으로 시각화했다. `}</p>
          <p className="s39 s40">{`영상 속 구슬은 아이디어를, 서로 다른 형태와 색의 투명 구조물은 각 AI의 역할과 특성을 상징한다. 딩 실험자가 AI CORE에 구슬을 투입하면 `}</p>
          <p className="s39 s40">{`구슬이 여러 튜브를 빠르게 통과하고, 경로가 나뉘거나 다시 결합되며 탐색·해석·생성의 과정을 보여준다. 가공된 결과는 모니터를 통해 `}</p>
          <p className="s39 s40">{`출력된 뒤 다시 새로운 아이디어로 이어진다. ‘LET THE IDEAS ROLL, PLAY THE LAB’을 중심으로 AI를 직접 연결하고 실험하며 가능성을 `}</p>
          <p className="s39">발견하는 Play Lab의 정체성을 영상 전체의 흐름에 담았다.</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s60 s27 s29 s61 s241 s54" data-node-id="886:1471">
        MOTION
      </p>
      <p className="s23 s2 s31 s32 s63 s27 s29 s64 s242 s66" data-node-id="886:1472">
        WORK
      </p>
      <div className="s2 s67 s63 s243" data-node-id="886:1473">
        <div className="s2 s69 s63 s70 s243 s71" data-node-id="886:1474" data-name="이미지 2026. 9. 2. 오후 3.38 2">
          <div className="s2 s3 s6 s4 s70">
            <img alt="" className="s2 s72 s73 s9 s74 s75" src={img2026923382} />
          </div>
        </div>
        <div className="s2 s80 s81 s69 s63 s82 s70 s243 s71" data-node-id="886:1476" />
      </div>
      <a className="s2 s67 s141 s91 s243" data-node-id="886:1478">
        <div className="s2 s244 s245 s254 s70 s247 s248" data-node-id="886:1479" data-name="이미지 2026. 9. 2. 오후 3.37 2">
          <div className="s2 s3 s6 s4 s70">
            <img alt="" className="s2 s7 s89 s9 s10 s90" src={img2026923372} />
          </div>
        </div>
        <div className="s2 s76 s77 s69 s91 s70 s92 s79 s243 s71" data-node-id="886:1480" />
        <div className="s2 s69 s255 s82 s4 s70 s146 s243 s71" data-node-id="886:1481">
          <div aria-hidden className="s2 s3 s70" style={{ backgroundImage: "linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), linear-gradient(90deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.16) 100%)" }} />
          <div className="s2 s3 s150 s151" />
        </div>
        <div className="s23 s2 s31 s36 s256 s27 s251 s115 s138 s257 s253 s54" data-node-id="886:1482">
          <p className="s249 s40">IMAge</p>
          <p className="s249">assets</p>
        </div>
      </a>
      <div className="s2 s97 s98 s240 s99" data-node-id="886:1483" data-name="이미지 1184 3">
        <div className="s2 s3 s6 s4">
          <img alt="" className="s2 s7 s100 s9 s10 s101" src={img11843} />
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="886:1484">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="886:1485" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="886:1486">
          <div className="s111 s0 s28 s112" data-node-id="886:1487" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="886:1492">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="886:1493">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="886:1494">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:1495">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:1496">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="886:1497">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:1498">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:1499">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="886:1500">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:1501">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:1502">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}